import { Chip, Divider, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { FlexBox } from "ui/components/FlexBox"
import { IUserTag } from "user-tag/model"
import { deleteUserTag } from "user-tag/tools/common"
import { UserTagAdd } from "./UserTagAdd"

interface IUserTagsProps {
  tags: IUserTag[]
}

const UserTagsFn = React.memo(({ tags }: IUserTagsProps) => (
  <FlexBox
    fullWidth
    jc="start"
    ai="start"
    vertical
    gap=".5rem"
    sx={{
      overflow: "auto",
      p: ".5rem",
      pt: 0
    }}>
    <UserTagAdd />
    <Divider sx={{ width: "calc(100% - 1rem)", m: ".5rem" }} />
    <Typography color="textPrimary" fontWeight={500} fontSize=".9rem">
      {translate("tag.list")}
    </Typography>
    <FlexBox gap>
      {tags.length === 0 && (
        <Typography color="textSecondary" fontSize=".9rem" marginLeft=".5rem">
          {translate("tag.empty")}
        </Typography>
      )}
      {tags.map((t, index) => (
        <Chip id={`user-tag-${index}`} label={t.name} onDelete={() => deleteUserTag(t.id, t.name)} key={index} />
      ))}
    </FlexBox>
  </FlexBox>
))

export const UserTags = connect(
  (state: IRootState): IUserTagsProps => ({
    tags: state.tag.userTags
  })
)(UserTagsFn)
